import {useEffect, useState} from "react";
import {configApi} from "@/boxhub-api";

type Props = {
    action: string;
};

export const useRecaptchaV3 = ({ action }: Props) => {
    const [error, setError] = useState<string | undefined>(undefined);
    const [siteKey, setSiteKey] = useState<string | undefined>(undefined);
    const [token, setToken] = useState<string | undefined>(undefined);

    useEffect(() => {
        configApi.getRecaptchaKey().then((r) => {
            setSiteKey(r.data);
        });
    }, []);

    useEffect(() => {
        const cleanupRecaptcha = () => {
            // Remove the main script
            const mainScript = document.getElementById("__recaptcha_script__");
            if (mainScript) {
                mainScript.remove();
            }

            // Remove all reCAPTCHA related scripts
            const scripts = document.querySelectorAll('script[src*="recaptcha"], script[src*="gstatic.com/recaptcha"]');
            scripts.forEach((script) => script.remove());

            // Remove reCAPTCHA badge
            const badge = document.querySelector(".grecaptcha-badge");
            if (badge) {
                badge.remove();
            }

            // Remove any other reCAPTCHA elements
            const recaptchaElements = document.querySelectorAll('[class*="recaptcha"], [id*="recaptcha"]');
            recaptchaElements.forEach((element) => element.remove());

            // Clean up global objects
            delete (window as any).grecaptcha;
            delete (window as any).___grecaptcha_cfg;
        };

        if (siteKey != null) {
            const script = document.createElement("script");
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.async = true;
            script.onload = () => {
                const windowAny: any = window;
                windowAny.grecaptcha.ready(() => {
                    windowAny.grecaptcha
                        .execute(siteKey, { action })
                        .then(setToken)
                        .catch(() => setError("reCAPTCHA Token konnte nicht erzeugt werden"));
                });
            };
            script.onerror = () => setError("reCAPTCHA konnte nicht geladen werden");
            document.head.appendChild(script);
            return cleanupRecaptcha;
        }
        return () => {};
    }, [action, siteKey]);

    return [token, siteKey, error];
};
